import { HttpMethod } from "@/types/https";
import { apiCall } from "../base";
import { ENDPOINT } from "../endpoint";

export const GetPartProcesses = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `GetPartProcesses_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.PART_PROCESSES,
        method: HttpMethod.GET,
      }),
  };
};

export const PartProcessFieldMetadata = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `PartProcessFieldMetadata_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: `${ENDPOINT.PART_PROCESS_FIELD_METADATA}`,
        method: HttpMethod.GET,
      }),
  };
};

export const AddPartProcessData = (body: any) => {
  return apiCall<any>({
    body,
    url: `${ENDPOINT.PART_PROCESS}`,
    method: HttpMethod.POST,
  });
};

export const DeletePartProcessData = (id: number) => {
  return apiCall<any>({
    url: `${ENDPOINT.PART_PROCESS}/${id}`,
    method: HttpMethod.DELETE,
  });
};

export const UpdatePartProcessField = (id: number, body: any) => {
  return apiCall<any>({
    body,
    url: `${ENDPOINT.PART_PROCESS}/${id}/field`,
    method: HttpMethod.PUT,
  });
};
